import icon_setting from '../../assets/icon_setting.png'
import icon_back from '../../assets/icon_back.png'
import icon_setting2 from '../../assets/icon_setting2.png'
import icon_back2 from '../../assets/icon_back2.png'

var store = {
  state: {
    left_icon: icon_back,
    right_icon: icon_setting,
    showRight: true,
    hideBack: false,
    title: '智能来电助理',
    whiteFont: false,
    backColor: '#ffffff',
    headStyle: 0
  },
  setTitle (title) {
    this.reset()
    this.state.title = title
  },
  reset () {
    if (this.state.left_icon !== icon_back) {
      this.state.left_icon = icon_back
    }
    if (this.state.right_icon !== icon_setting) {
      this.state.right_icon = icon_setting
    }
    if (this.state.showRight !== false) {
      this.state.showRight = false
    }
    if (this.state.hideBack !== false) {
      this.state.hideBack = false
    }
    if (this.state.whiteFont !== false) {
      this.state.whiteFont = false
    }
    if (this.state.backColor !== '#ffffff') {
      this.state.backColor = '#ffffff'
    }

    if (this.state.headStyle !== 0) {
      this.state.headStyle = 0
    }

    if (this.state.showvipicon !== false) {
      this.state.showvipicon = false
    }
  },

  hideBack () {
    // this.state.hideBack = true
  },

  showRight () {
    this.state.showRight = true
  },

  showvipicon () {
    this.state.showvipicon = true
  },

  // 一般设置颜色后需要重置字体
  changeWhiteText (whiteFont) {
    if (whiteFont) {
      this.state.left_icon = icon_back2
      this.state.right_icon = icon_setting2
      this.state.whiteFont = true
    } else {
      this.state.left_icon = icon_back
      this.state.right_icon = icon_setting
      this.state.whiteFont = false
    }
  },

  changeBackGround (color) {
    this.state.backColor = color
  },

  setHeadStyle (style) {
    this.state.headStyle = style
  }

}

export default {
  store
}



// WEBPACK FOOTER //
// ./src/components/widgets/TitleBarStore.js